import React, { Component } from "react"
import ParkingProductHighlightElement from "./parkingProductHighlightElement"
import Spinner from "../spinner"
import { getContentEnrichedProduct } from "../../helpers/bookingHelper"
import config from "react-global-configuration"
import ParkingProductHighlightElementNew from "./parkingProductHighlightElementNew"
import Slider from "react-slick"
import { parkingState } from "../../zustand/parkingState"
import priceFormatter from "../../helpers/priceFormatter"
import { handleReservation } from "../../helpers/apiHelper"

class ParkingProductHighlight extends Component {
  constructor(props) {
    super(props)

    this.state = {
      highlights: [],
    }
  }

  handleStateChange(state) {
    if (parkingState.getState().stateHandler) {
      parkingState.getState().stateHandler(state)
    } else {
      parkingState.setState(state)
    }
  }

  componentDidMount() {
    const highlights = parkingState.getState().parkingHighlights
    if (highlights) {
      this.setState({ highlights })
    }

    // Add a listener to update highlights when parkingState changes
    this.unsubscribe = parkingState.subscribe((state) => {
      if (state.parkingHighlights !== this.state.highlights) {
        this.setState({ highlights: state.parkingHighlights })
      }
    })

    window.addEventListener("resize", () => {
      this.setState({ screenWidth: window.innerWidth })
    })
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  getProductData(highlights) {
    if (highlights && Object.keys(highlights).length > 0) {
      let highlightsAsArray = Object.keys(highlights).map((prop) => {
        if (highlights && highlights[prop]) return highlights[prop]?.products[0]
      })
      let contentEnrichedProducts = highlightsAsArray.map(
        (resultProduct) => resultProduct && getContentEnrichedProduct(resultProduct, config.get("content")),
      )
      return contentEnrichedProducts
    }
    return []
  }

  handleSpecialProductClick = (highlightProduct) => {
    this.handleStateChange({
      parkingDetailsModalGaList: parkingState.getState().gaList,
      parkingDetailsModalGaListIndex: parkingState.getState().gaListIndex,
      isParkingSpecialProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(highlightProduct, config.get("content")),
    })
  }

  handleMemberProductClick = (highlightProduct) => {
    this.handleStateChange({
      parkingDetailsModalGaList: parkingState.getState().gaList,
      parkingDetailsModalGaListIndex: parkingState.getState().gaListIndex,
      isParkingMemberProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(highlightProduct, config.get("content")),
    })
  }

  handleBuyClickFunction = (item) => {
    const { product, result } = item

    parkingState.setState({ latestHistoryForModal: this.props.history })

    const isSpecialProduct = product && product.dynamicFields && product.dynamicFields.isSpecialProduct
    const showMemberprice = result?.showMemberPrice

    const { userAccountDetails } = parkingState.getState()

    const isLoggedIn = !!userAccountDetails

    isSpecialProduct
      ? this.handleSpecialProductClick(item)
      : showMemberprice && !isLoggedIn
        ? this.handleMemberProductClick(item)
        : handleReservation(product.id, item, null, this.props.history)
  }

  checkForPromoBanner = (hightlightProducts) => {
    const { globals } = parkingState.getState()
    let hasPromoLabel = false
    hightlightProducts.every((highlightProduct) => {
      if (!highlightProduct) {
        return
      }
      const { result, product } = highlightProduct
      let promotionBanner =
        result.originalPrice > result.totalPrice && globals.promotionName
          ? globals.promotionName
          : result && result.thirdPartyPromoLabelText
            ? result.thirdPartyPromoLabelText
            : product.dynamicFields && product.dynamicFields.calloutBanner
              ? product.dynamicFields.calloutBanner
              : undefined

      const affiliateCheck = parkingState.getState().affiliateCode && result.affiliateResult && product.dynamicFields.affiliateBanner
      if (affiliateCheck) {
        promotionBanner = product.dynamicFields.affiliateBanner
      }

      if (promotionBanner) {
        hasPromoLabel = true
        return false
      }
      return true
    })
    return hasPromoLabel
  }

  getHighlightElements = (hightlightProducts) => {
    if (!hightlightProducts || hightlightProducts.length === 0) return null

    const { userAccountDetails, globals, uspLimit } = parkingState.getState()
    const isLoggedIn = !!userAccountDetails
    const parkingListListElementTextKeys = config.get("textKeys.parkingList.listElement") || {}
    const typeTexts = config.get("textKeys.productHighlights.typeText")

    const highlights = hightlightProducts.map((highlightProduct, index) => {
      if (!highlightProduct) return null

      const { result, product } = highlightProduct
      let promotionBanner =
        result.originalPrice > result.totalPrice && globals.promotionName
          ? globals.promotionName
          : result && result.thirdPartyPromoLabelText
            ? result.thirdPartyPromoLabelText
            : product.dynamicFields && product.dynamicFields.calloutBanner
              ? product.dynamicFields.calloutBanner
              : undefined
      // use affiliateBanner if an affiliateCode is active
      const affiliateCheck = parkingState.getState().affiliateCode && result.affiliateResult && product.dynamicFields.affiliateBanner
      if (affiliateCheck) {
        promotionBanner = product.dynamicFields.affiliateBanner
      }

      // threshold defined by CPH
      highlightProduct.urgency = Math.abs(product.maxCapacity - product.currentlyBooked) <= 25 && !product.isSoldOut

      let limit = 1
      let usp = {}
      let typeText = ""
      let buyButtonId = ""
      let mapButtonId = ""
      let readMoreButtonId = ""

      const buttonOnClickFunction = () => this.handleBuyClickFunction(highlightProduct)

      // left
      if (index === 0) {
        //2 //
        limit = 2
        typeText = typeTexts?.productHighlightStep1TypeText || "Billigeste parkering"
        buyButtonId = "cheapestbuybutton"
        mapButtonId = "cheapestmapbutton"
        readMoreButtonId = "cheapestreadmorebutton"
      }
      // right
      if (index === 2) {
        // 3
        limit = 3
        typeText = typeTexts?.productHighlightStep3TypeText || "Bedst til prisen"
        buyButtonId = "bestpricebuybutton"
        mapButtonId = "bestpricemapbutton"
        readMoreButtonId = "bestpricereadmorebutton"
      }
      // center
      if (index === 1) {
        // 6
        limit = 6
        typeText = typeTexts?.productHighlightStep2TypeText || "Lige ved terminalerne"
        buyButtonId = "terminalbuybutton"
        mapButtonId = "terminalmapbutton"
        readMoreButtonId = "terminalreadmorebutton"
      }

      const conf = config.get("content")

      var carParkContent = conf.carParks[highlightProduct?.location]

      if (parkingState.getState().useNewDesign) {
        if (carParkContent && carParkContent.usp && carParkContent.usp.bullets) {
          limit = uspLimit
          usp.headline = carParkContent.usp.headline
          usp.bullets = carParkContent.usp.bullets.slice(0, limit)
        }
      } else {
        if (highlightProduct && highlightProduct.usp && highlightProduct.usp.bullets) {
          usp.headline = highlightProduct.usp.headline
          usp.bullets = highlightProduct.usp.bullets.slice(0, limit)
        }
      }

      if (parkingState.getState().useNewDesign) {
        return (
          <ParkingProductHighlightElementNew
            key={index}
            {...highlightProduct}
            arrivalDate={parkingState.getState().arrivalDate}
            arrivalTime={parkingState.getState().arrivalTime}
            departureDate={parkingState.getState().departureDate}
            departureTime={parkingState.getState().departureTime}
            typeText={typeText}
            usp={usp}
            ribbonText={promotionBanner}
            modalButtonOnClick={() =>
              this.handleStateChange({
                parkingDetailsModalGaList: parkingState.getState().gaList,
                parkingDetailsModalGaListIndex: parkingState.getState().gaListIndex,
                isParkingDetailsModalActive: true,
                isParkingHighlightModalActive: true,
                parkingDetailsModalItem: getContentEnrichedProduct(highlightProduct, conf),
              })
            }
            buttonOnClick={highlightProduct.product.isSoldOut ? undefined : buttonOnClickFunction.bind(this)}
            priceFormatter={priceFormatter}
            buttonClass={highlightProduct.product.isSoldOut ? "is-disabled" : ""}
            buttonText={
              highlightProduct.product.isSoldOut
                ? parkingListListElementTextKeys.soldOut || "Udsolgt"
                : parkingListListElementTextKeys.reserve || "Reservér"
            }
            isLoggedIn={isLoggedIn}
            flightId={parkingState.getState().flightId}
            mapOnClick={() =>
              this.handleStateChange({
                parkingDetailsModalItem: highlightProduct,
              })
            }
            spacer={!!promotionBanner && !parkingState.getState().enableCarousel ? "spacer" : ""}
            affiliateCode={parkingState.getState().affiliateCode}
            globals={parkingState.getState().globals}
            buyButtonId={buyButtonId}
            mapButtonId={mapButtonId}
            readMoreButtonId={readMoreButtonId}
            history={this.props.history}
          />
        )
      }

      return (
        <ParkingProductHighlightElement
          key={index}
          {...highlightProduct}
          arrivalDate={parkingState.getState().arrivalDate}
          arrivalTime={parkingState.getState().arrivalTime}
          departureDate={parkingState.getState().departureDate}
          departureTime={parkingState.getState().departureTime}
          typeText={typeText}
          usp={usp}
          ribbonText={promotionBanner}
          modalButtonOnClick={() =>
            this.handleStateChange({
              parkingDetailsModalGaList: parkingState.getState().gaList,
              parkingDetailsModalGaListIndex: parkingState.getState().gaListIndex,
              isParkingDetailsModalActive: true,
              isParkingHighlightModalActive: true,
              parkingDetailsModalItem: highlightProduct,
            })
          }
          buttonOnClick={highlightProduct.product.isSoldOut ? undefined : buttonOnClickFunction.bind(this)}
          priceFormatter={priceFormatter}
          buttonClass={highlightProduct.product.isSoldOut ? "is-disabled" : ""}
          buttonText={
            highlightProduct.product.isSoldOut
              ? parkingListListElementTextKeys.soldOut || "Udsolgt"
              : parkingListListElementTextKeys.reserve || "Reservér"
          }
          isLoggedIn={isLoggedIn}
          flightId={parkingState.getState().flightId}
          affiliateCode={parkingState.getState().affiliateCode}
          globals={parkingState.getState().globals}
          history={this.props.history}
        />
      )
    })

    return highlights
  }

  render() {
    const { deck, wrapper, useNewDesign, enableCarousel } = this.props
    const hightlightProducts = this.getProductData(this.state.highlights) // Use state highlights
    const hasPromoLabel = this.checkForPromoBanner(hightlightProducts)
    const hightlightElements = this.getHighlightElements(hightlightProducts)

    const innerWidth = window.innerWidth
    var settings = {
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      variableWidth: true,
    }

    const style = { "--slick-element-width": `${innerWidth * 0.65}px` }

    if (useNewDesign && enableCarousel && innerWidth <= 567) {
      return (
        <section className={`${deck} ${hasPromoLabel ? "deck--parking-podium" : ""}`}>
          <Spinner isActive={parkingState.getState().ajaxSpinnerActive} isTransparent={parkingState.getState().ajaxSpinnerTransparent} />
          <div className="podium-slider" style={style}>
            <Slider {...settings}>{hightlightElements}</Slider>
          </div>
        </section>
      )
    }

    return (
      <section className={`${deck} ${innerWidth >= 768 ? "deck--padding-bottom" : ""} ${hasPromoLabel ? "deck--parking-podium" : ""}`}>
        <div className={wrapper}>
          <Spinner isActive={parkingState.getState().ajaxSpinnerActive} isTransparent={parkingState.getState().ajaxSpinnerTransparent} />
          <div className="grid">{hightlightElements}</div>
        </div>
      </section>
    )
  }
}

export default ParkingProductHighlight
